export const MapUserConstants = {
  FETCH_MAP_USER_REQUEST: "FETCH_MAP_USER_REQUEST",
  FETCH_MAP_USER_SUCCESS: "FETCH_MAP_USER_SUCCESS",
  FETCH_MAP_USER_FAILURE: "FETCH_MAP_USER_FAILURE",

  SAVE_MAP_USER_REQUEST: "SAVE_MAP_USER_REQUEST",
  SAVE_MAP_USER_SUCCESS: "SAVE_MAP_USER_SUCCESS",
  SAVE_MAP_USER_FAILURE: "SAVE_MAP_USER_FAILURE",

  GET_MAP_USER_REQUEST: "GET_MAP_USER_REQUEST",
  GET_MAP_USER_SUCCESS: "GET_MAP_USER_SUCCESS",
  GET_MAP_USER_FAILURE: "GET_MAP_USER_FAILURE",
};
